__turbopack_context__.v({
  "afb__preview-link": "jzCoBa_afb__preview-link",
  "bookCard": "jzCoBa_bookCard",
  "center": "jzCoBa_center",
});
